import { createTheme } from "@mui/material/styles";
import vsDarkTheme from "./vsDarkTheme";

// Unix terminal aesthetic extension of the VS Dark base theme.
// Uses the two-argument createTheme(base, overrides) form so all palette
// keys — including the custom ones (string, comment, keyword, symbol) —
// are inherited without being redeclared here.
const blogTheme = createTheme(vsDarkTheme, {
  palette: {
    background: {
      default: "#0d0d0d",
      paper: "#1a1a1a",
    },
    text: {
      primary: "#f0f0f0",
    },
  },
  typography: {
    fontFamily: "'Fira Code', monospace",
    h1: {
      fontFamily: "'Fira Code', monospace",
      fontWeight: 700,
      fontSize: "2.5rem",
      color: "#569cd6",
    },
    h2: {
      fontFamily: "'Fira Code', monospace",
      color: "#d7ba7d",
    },
    h3: {
      fontFamily: "'Fira Code', monospace",
      color: "#9cdcfe",
    },
    h4: {
      fontFamily: "'Fira Code', monospace",
      color: "#9cdcfe",
    },
    body1: {
      fontFamily: "'Inter', 'Segoe UI', system-ui, sans-serif",
      lineHeight: 1.75,
      fontSize: "1rem",
    },
    body2: {
      fontFamily: "'Inter', 'Segoe UI', system-ui, sans-serif",
      lineHeight: 1.75,
      fontSize: "1rem",
    },
  },
});

export default blogTheme;
